import { Skeleton } from "@heroui/react";

export const TutorialPageSkeleton = () => (
  <div aria-label="Loading tutorials" className="w-full px-4 py-4 sm:px-8">
    <div className="mb-7 flex flex-wrap justify-between gap-4">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-7 w-64 rounded-(--field-radius)" />
        <Skeleton className="h-5 w-72 rounded-(--field-radius)" />
      </div>
      <Skeleton className="h-9 w-75 max-lg:w-full rounded-(--field-radius)" />
    </div>
    <Skeleton className="mb-2.5 h-6 w-28 rounded-(--field-radius)" />
    <div className="divide-y divide-border overflow-hidden rounded-(--field-radius) border border-border bg-surface">
      {[0, 1, 2, 3, 4].map((row) => (
        <div key={row} className="flex items-center gap-4.5 px-5 py-4">
          <Skeleton className="aspect-[40/21] w-28 shrink-0 rounded-(--field-radius) lg:w-38" />
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <Skeleton className="h-5 w-3/4 rounded-(--field-radius)" />
            <Skeleton className="h-4 w-1/2 rounded-(--field-radius)" />
            <Skeleton className="h-4 w-full rounded-(--field-radius)" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
